import { useCallback } from 'react';
import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { extractFirstValidationError } from '~/modules/common/graphql/errors';

export const UPDATE_CLIENT_BILLING_INFO = gql`
  mutation UpdateClientBilling($input: UpdateClientBillingInfoInput!) {
    updateClientBillingInfo2(input: $input) {
      client {
        id
        defaultInvoicePaymentTerm
        invoiceCurrency {
          id
          symbol
        }
        taxProfile {
          id
          displayText
        }
        invoiceTemplate {
          id
          displayText
        }
      }
    }
  }
`;

export const useUpdateClientBillingInfo = closeDialog => {
  const [updateClientBillingInfo] = useMutation(UPDATE_CLIENT_BILLING_INFO);

  const onSubmit = useCallback(
    async (values, { resetForm, setSubmitting, setFieldError }) => {
      const {
        id,
        taxProfile,
        invoiceCurrency,
        defaultInvoicePaymentTerm,
        invoiceTemplate
      } = values;

      try {
        await updateClientBillingInfo({
          variables: {
            input: {
              id,
              taxProfileUri: taxProfile ? taxProfile.id : null,
              invoiceCurrencyUri: invoiceCurrency.id,
              defaultInvoicePaymentTerm: defaultInvoicePaymentTerm || 0,
              invoiceTemplateUri: invoiceTemplate ? invoiceTemplate.id : null
            }
          },
          optimisticResponse: {
            __typename: 'Mutation',
            updateClientBillingInfo2: {
              __typename: 'UpdateClientBillingInfoResponse',
              client: {
                __typename: 'Client',
                id,
                taxProfile,
                invoiceCurrency,
                defaultInvoicePaymentTerm,
                invoiceTemplate
              }
            }
          }
        });
        closeDialog();
        resetForm();
      } catch (error) {
        const validationErrors = extractFirstValidationError(error);

        setFieldError('billingInfo', validationErrors);
      } finally {
        setSubmitting(false);
      }
    },
    [closeDialog, updateClientBillingInfo]
  );

  return { onSubmit };
};
